<template>
  <div class="public-status">
    <!-- isProprietaryTask === false it means Task is Item Check -->
    <!-- isProprietaryTask === true it means Task is Rfider Authenticity Check -->
    <div class="mode-compact" :class="'compact-gradient' + result.status">
      <div v-if="isCompactCollapsed">
        <md-icon v-if="result.status === 0" class="compact-collapsed-icon"
          >pan_tool</md-icon
        >
        <md-icon v-if="result.status === 1" class="compact-collapsed-icon"
          >check_circle_outline</md-icon
        >
        <md-icon v-if="result.status === 2" class="compact-collapsed-icon"
          >warning</md-icon
        >
        <div class="md-layout">
          <div
            class="compact-collapsed-message md-layout-item md-size-95 md-xsmall-size-90"
            v-if="result.taskResultMessage"
          >
            {{ result.taskResultMessage }}
          </div>
          <md-button
            class="md-layout-item md-button md-white md-size-5 md-xsmall-size-10 md-simple md-just-icon compact-collapsed-btn"
            @click="isCompactCollapsed = !isCompactCollapsed"
            ><md-icon>info</md-icon></md-button
          >
        </div>
      </div>

      <div v-else class="mode-compact">
        <div>
          <md-icon class="compact-expanded-icon" v-if="result.status === 0"
            >pan_tool</md-icon
          >
          <md-icon class="compact-expanded-icon" v-if="result.status === 1"
            >check_circle_outline</md-icon
          >
          <md-icon class="compact-expanded-icon" v-if="result.status === 2"
            >warning</md-icon
          >
          <div class="md-layout">
            <div
              v-if="result.taskResultMessage"
              class="compact-collapsed-message md-layout-item md-size-95 md-xsmall-size-90"
            >
              {{ result.taskResultMessage }}
            </div>
            <md-button
              class="md-layout-item md-button md-white md-size-5 md-xsmall-size-10 md-simple md-just-icon compact-collapsed-btn compact-expanded-btn"
              @click="isCompactCollapsed = !isCompactCollapsed"
              ><md-icon>info</md-icon></md-button
            >
          </div>
        </div>
        <div class="compact-expanded-context">
          <div v-if="result.status === 0">
            {{ $t('public.result_status_red', { '0': organizationName }) }}
          </div>
          <div v-if="result.status === 1">
            {{ $t('public.result_status_green', { '0': organizationName }) }}
          </div>
          <div v-if="result.status === 2">
            {{ $t('public.result_status_yellow', { '0': organizationName }) }}
          </div>
          <div v-if="itemId" class="compact-expanded-context-space">
            {{ $t('public.result_status_itemId', { '0': itemId }) }}
          </div>
          <div v-if="batchId">
            {{ $t('public.result_status_batchId', { '0': batchId }) }}
          </div>
          <div v-if="isProprietaryTask">
            <md-divider></md-divider>
            <md-icon class="compact-expanded-context-icon"
              >verified_user</md-icon
            >
            <div class="compact-expanded-context-batch">
              {{ $t('public.result_message') }}
              <div>Ref: {{ interactionId }}</div>
            </div>
          </div>
          <div
            v-if="organizationName && result.urlContactUs"
            class="compact-expanded-context-space"
          >
            <a
              class="compact-expanded-context-contact"
              :href="result.urlContactUs"
              target="_blank"
              >Contact {{ organizationName }}</a
            >
          </div>
          <div
            v-if="result.urlLearnMore"
            class="compact-expanded-context-space"
          >
            <a
              class="compact-expanded-context-learn-more"
              :href="result.urlLearnMore"
              target="_blank"
              >Learn More</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isCompactCollapsed: true,
    };
  },
  props: {
    isProprietaryTask: {
      type: Boolean,
    },
    result: {
      type: Object,
    },
    itemId: {
      type: String,
    },
    organizationName: {
      type: String,
    },
    batchId: {
      type: String,
    },
    interactionId: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/public/_public-status.scss';
</style>
